import { projects } from '../data/projects';
import ProjectCard from '../components/ui/ProjectCard';
import SectionTitle from '../components/ui/SectionTitle';

export default function ProjectsPage() {
  return (
    <section>
      <div className="container">
        <SectionTitle title="开源项目" />
        <p className="page-intro">
          以下项目来自 GitHub 公开仓库，按活跃度与代表性整理。
        </p>
        <div className="projects-grid">
          {projects.map((p) => (
            <ProjectCard key={p.name} {...p} />
          ))}
        </div>
        <p className="archive-note">
          完整列表见{' '}
          <a href="https://github.com/YuFy1314?tab=repositories" target="_blank" rel="noopener noreferrer">
            github.com/YuFy1314
          </a>
        </p>
      </div>
    </section>
  );
}
